'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const galleryBig = document.querySelector('.gallery-big');
  const gallerySlides = document.querySelectorAll('.gallery-small__slide');

  if(galleryBig && gallerySlides) {
    gallerySlides.forEach((slide) => {
      slide.addEventListener('click', () => {
        swiffyslider.slideTo(galleryBig, slide.getAttribute('data-slide'));
      });
    });
  }
});